import React, {useState} from 'react';
import ConfirmationModal from "../ConfirmationModal";
import SimpleInput from "../../../components/UI/SimpleInput";
import {t} from 'i18next';
import {setError} from "@arboxappv4/shared/src/redux/siteSlice";
import {useDispatch} from 'react-redux';
import {isValidEmail} from "../../../helpers/functions";


const SendEmail = (props) => {
    const { isOpen, onClose, targetMail, onConfirm} = props;
    const [email, setEmail] = useState(targetMail ?? '');
    const [emailError, setEmailError] = useState(null);
    const dispatch = useDispatch();


    const confirm = () => {
        const validMail = isValidEmail(email)
        if(validMail && onConfirm) {
            onConfirm(email)
            onClose()
        }
        if(!validMail) {
            dispatch(setError(t('invalid-email-error')))
        }
    }

    const onBlur = (val) => {
        if (!isValidEmail(val)) {
            setEmailError(t('invalid-email-error'));
        }
        else {
            setEmailError(null);
        }
    };

    return (
        <ConfirmationModal isOpen={isOpen}
                           onClose={onClose}
                           onConfirm={confirm}
                           header={t('send-email-header')}
                           submitText={t('send')}
                           explanation={<div style={{width: '100%', marginBottom: '8px'}}>
                               <SimpleInput placeholder={t('send-email-placeholder')}
                                            value={email}
                                            onChangeCallback={(val) => setEmail(val)}
                                            status={emailError ? 'error' : null}
                                            onBlur={(e) => onBlur(e.target.value)}
                               />
                            </div>}/>
    );
};

export default SendEmail;